import { getFeatureAssetBaseUrl, resolveCustomAssetUrl } from '../../helpers/FeatureAssets';

// ─── Layout constants ──────────────────────────────────────────────────────────
// Layout is HORIZONTAL: row → X axis, column → Y axis
// Column 4 = main spine (vertical centre).
export const ROW_STEP   = 320;   // px per row (horizontal advance)
export const COL_STEP   = 160;   // px per column slot (vertical spread)
export const CENTER_COL = 4;     // data column that sits on the horizontal centre line
export const PAD_X      = 80;    // left/right padding
export const PAD_Y      = 60;    // top/bottom padding (relative to centre)

// Node geometry
export const CIRCLE_R           = 58;   // radius of circle nodes
export const CARD_W             = 200;  // width of customisation cards
export const CARD_H             = 90;   // height of standard cards
export const CARD_GAP           = 12;   // gap between stacked standard cards
export const VOTE_CARD_H        = 200;  // height of vote graphic cards
export const VOTE_CARD_GAP      = 14;   // gap between stacked vote graphic cards
export const DISRUPTOR_CARD_H   = 60;   // height of disruptor trigger stacked cards
export const DISRUPTOR_CARD_GAP = 10;   // gap between disruptor trigger stacked cards
export const DISRUPTOR_HEADER_H = 46;   // header band height for disruptor node (title + drag hint)
export const DISRUPTOR_FOOTER_H = 10;   // bottom padding below last card in disruptor node
export const LEADERBOARD_TRIGGER_W = 280; // width of the trivia leaderboard trigger node
export const LEADERBOARD_TRIGGER_H = 210; // total height of the trivia leaderboard trigger node
export const LEADERBOARD_START_AUDIO_W = 340;
export const LEADERBOARD_START_AUDIO_H = 178;
export const LEADERBOARD_SETTINGS_W = 520;
export const LEADERBOARD_SETTINGS_H = 264;
export const LEADERBOARD_DATA_W = 590;
export const LEADERBOARD_DATA_HEADER_H = 44;
export const LEADERBOARD_DATA_ROW_H = 118;
export const LEADERBOARD_DATA_ROW_GAP = 12;
export const LEADERBOARD_DATA_FOOTER_H = 42;
export const TRIVIA_NODE_W       = 510;  // wider round/question node for dense trivia lists
export const WINNER_IMG_H       = 110;  // image area inside winner combined node
export const WINNER_NODE_H      = 240;  // total height of waveWinner combined node
export const PLUS_R             = 11;   // radius of the + add-graphic circle on connector lines
export const IMAGE_STACK_CARD_H = 196;  // height of image overlay cards
export const IMAGE_STACK_CARD_GAP = 12; // gap between stacked image overlay cards
export const PARTICLE_SETTINGS_H = 206; // fixed height of the confetti settings summary node
export const PARTICLE_TIMER_H    = 254; // fixed height of the live-time timer node

// Countdown node geometry
export const COUNTDOWN_SETTINGS_W  = 280;  // wider than CARD_W — gives dropdown room
export const COUNTDOWN_SETTINGS_H  = 90;   // header + one type-selector row
export const COUNTDOWN_TIMER_H     = 280;  // same profile as PARTICLE_TIMER_H
export const COUNTDOWN_CARD_H      = 150;  // height of each image/text card in the stack
export const COUNTDOWN_CARD_GAP    = 16;   // gap between countdown stack cards
export const ANIMATED_OVERLAY_MAIN_VIEW_W = 280;
export const ANIMATED_OVERLAY_MAIN_VIEW_H = 90;

// Video disruptor node geometry
export const VIDEO_SETTINGS_W      = 300;
export const VIDEO_SETTINGS_H      = 200;
export const VIDEO_CARD_W          = 240;
export const VIDEO_CARD_H          = 184;
export const VIDEO_CARD_GAP        = 18;

// Sub Bomb node geometry
export const SUB_BOMB_DISPLAY_H    = 236;
export const SUB_BOMB_SPEED_H      = 244;

// Audio disruptor node geometry
export const AUDIO_CARD_W          = 240;
export const AUDIO_CARD_H          = 132;
export const AUDIO_CARD_GAP        = 18;

// Preset text node geometry
export const PRESET_TEXT_W        = 480;   // width of each preset text card
export const PRESET_TEXT_CARD_H   = 178;   // height of each editable preset card
export const PRESET_TEXT_CARD_H_NO_HEADER = 136; // height when header field is disabled
export const PRESET_TEXT_CARD_GAP = 24;    // gap between preset cards

// Goals node geometry
export const GOAL_CARD_W          = 160;  // width of each individual goal card inside GoalsNode
export const GOAL_CARD_H_CONTENT  = 558;  // content area height of each goal card
export const GOAL_CARD_GAP        = 10;   // gap between goal cards (horizontal)
export const GOALS_HEADER_H       = 46;   // header band height inside GoalsNode
export const GOALS_NODE_PADDING   = 16;   // left + right inner padding of GoalsNode
export const GOALS_NODE_H = GOALS_HEADER_H + GOAL_CARD_H_CONTENT + 56; // total GoalsNode height

// Poll-specific geometry
export const POLL_CARD_H           = 68;   // height of each collapsed poll card
export const POLL_CARD_GAP         = 10;   // gap between poll cards
export const POLL_AUDIO_HEADER_H   = 54;   // header band height for audio node
export const POLL_AUDIO_SLOT_LBL_H = 26;   // slot label row height
export const POLL_AUDIO_FILE_H     = 76;   // height of one configured audio file row
export const POLL_AUDIO_FILE_GAP   = 6;    // gap between stacked audio files
export const POLL_AUDIO_EMPTY_H    = 46;   // empty-state CTA height
export const POLL_AUDIO_ADD_BTN_H  = 30;   // "＋ Add another file" row height
export const POLL_AUDIO_SLOT_GAP   = 14;   // gap between slots
export const POLL_OUTCOME_H        = 200;  // fixed height of a poll outcome compound node
export const POLL_TRIGGER_PANEL_GAP = 14;  // gap between poll card and inline trigger panel
export const POLL_TRIGGER_PANEL_W   = 200; // width of inline per-poll trigger panel

export const SLOT_REELS_W          = 1120;
export const SLOT_REELS_COL_W      = 220;
export const SLOT_REELS_COL_GAP    = 12;
export const SLOT_REELS_NODE_PADDING = 16;
export const SLOT_REELS_HEADER_H   = 52;
export const SLOT_REELS_ITEM_H     = 226;
export const SLOT_REELS_ITEM_GAP   = 10;
export const SLOT_REELS_NODE_H     = SLOT_REELS_HEADER_H + SLOT_REELS_ITEM_H + 84;
export const SLOT_REELS_COUNT_W    = 200; // inline reels-count selector node width
export const SLOT_REELS_COUNT_BASE_H = 254; // gauge section height (unchanged — anchors GAUGE_CY)
export const SLOT_REELS_COUNT_SPIN_SEQ_H = 100; // spin-sequence section appended below gauge
export const SLOT_REELS_COUNT_H    = SLOT_REELS_COUNT_BASE_H + SLOT_REELS_COUNT_SPIN_SEQ_H; // total node height
export const SLOT_RESULTS_W        = 380;
export const SLOT_RESULTS_HEADER_H = 36;
export const SLOT_RESULTS_ROW_H    = 220;
export const SLOT_RESULTS_ROW_GAP  = 12;
export const SLOT_RESULTS_ADD_H    = 32;

// Decision node geometry (diamond shape)
export const DIAMOND_W   = 140;  // full bounding-box width of decision diamond
export const DIAMOND_H   = 140;  // full bounding-box height of decision diamond

// Outcome node geometry (solid coloured rectangle)
export const OUTCOME_W   = 200;  // width of outcome node
export const OUTCOME_H   = 70;   // height of outcome node

// Info Box node geometry (inline header + body copy editing)
export const INFO_BOX_NODE_H = 204;  // total height of the info box editable node

// Puzzle stack geometry
// Must fit: header + puzzle image + divider + equally sized solution section + CTA chip/button.
export const PUZZLE_CARD_H   = 292;  // height of each puzzle card (prevents content overlap with 100px solution box)
export const PUZZLE_CARD_GAP = 12;   // gap between puzzle cards

// Wave-specific branch geometry
export const BRANCH_VSEP = 28;   // fork offset: vote-image branches up, hashtag branches down
export const BRANCH_STEM = 110;  // minimum horizontal stem length from circle edge
export const TRIG_W      = 210;  // width of trigger nodes
export const TRIG_H      = 64;   // height of trigger nodes
export const HASH_GAP    = 34;   // px gap between bottom of card stack and top of hashtag box

// ─── Colour palette ────────────────────────────────────────────────────────────
// All theme-sensitive colours use CSS custom properties so they switch
// automatically between light and dark mode.  Brand/semantic colours that must
// remain constant in both themes keep their literal hex values.
export const C = {
  canvasBg:    'var(--fc-canvas-bg)',
  card:        'var(--fc-card-bg)',
  cardSel:     'var(--fc-card-sel-bg)',
  circle:      'var(--fc-circle-bg)',
  border:      'var(--fc-border)',
  purple:      '#9146FF',               // brand colour — constant
  purpleDim:   'rgba(145,70,255,0.25)', // brand colour — constant
  green:       '#4ade80',               // semantic success — constant
  greenText:   'var(--fc-green-text)',   // green for TEXT — darker in light mode
  orange:      '#f97316',               // semantic warning — constant
  text:        'var(--fc-text)',
  textMuted:   'var(--fc-text-muted)',
  textDim:     'var(--fc-text-dim)',
  dot:         'var(--fc-dot)',
  sel:         '#c060ff',               // selection highlight — constant
  neonBlue:    '#00aaff',               // info buttons — constant
  red:         '#ef4444',               // end title nodes — constant
  progress:    'var(--fc-progress-track-bg)', // progress bar track bg
  tintSuccess: 'rgba(74,222,128,0.15)',  // green tint — semi-transparent, works on both themes
  tintDanger:  'rgba(239,68,68,0.12)',   // red tint  — semi-transparent, works on both themes
  inputText:   'var(--fc-text)',         // text inside foreignObject inputs
  inputBorder: 'var(--fc-border)',       // border for foreignObject inputs
  innerBg:     'var(--fc-circle-bg)',    // inner/subdued panel background
};

// ─── Feature icon map ──────────────────────────────────────────────────────────
export const FEATURE_ICON_MAP = {
  wave: '🌊', flock_to_unlock: '🔓', object_stacker: '📚',
  object_zapper: '⚡', image_slider: '🖼️', live_poll: '📊',
  audio_disruptor: '🔊', video_disruptor: '🎬', fireworks: '🎆',
  confetti: '🎊', info_panel: 'ℹ️', quiz_poll: '❓',
  leaderboard: '🏆', countdown: '⏱️', status_screens: '📺',
  animated_overlay: '✨', image_overlay: '🖼️', sub_bomb: '💣',
  live_text: '📝', randomiser: '🎲', particle_effects: '✨',
  slide_puzzle: '🧩', claw_machine: '🎰',
};

const normalizeFeatureId = (value) => {
  if (value == null) return null;
  if (typeof value === 'string') return value;
  if (typeof value === 'object') {
    if (typeof value._id === 'string') return value._id;
    if (typeof value.id === 'string') return value.id;
  }

  const stringValue = value?.toString?.();
  if (typeof stringValue === 'string' && stringValue !== '[object Object]') {
    return stringValue;
  }

  return null;
};

export function resolveFeatureIconAndLabel(id, campaignFeatures) {
  if (!id) return { label: 'Drop component here', icon: '🎬' };
  const features = Array.isArray(campaignFeatures) ? campaignFeatures : [];
  const targetId = normalizeFeatureId(id);
  const match = features.find((feature) => {
    const featureId = normalizeFeatureId(feature?._id) || normalizeFeatureId(feature?.id);
    return featureId && targetId && featureId === targetId;
  });
  if (match) {
    const label = match.contentLabel || match.feature?.featureName || 'Component';
    const varKey = match.varKey || match.feature?.varKey || '';
    const featureType = match.feature?.featureType || 'disruptor';
    const featureCategory = match.feature?.featureCategory || match.featureCategory || null;
    const icon = match.icon || match.feature?.icon || null;
    return { label, icon, varKey, featureType, featureCategory };
  }
  return {
    label: typeof targetId === 'string' ? (targetId.length > 20 ? targetId.slice(0, 20) + '…' : targetId) : 'Disruptor',
    icon: '🎬',
    varKey: '',
    featureType: 'disruptor',
    featureCategory: null,
  };
}

// ─── Asset URL helpers ─────────────────────────────────────────────────────────
export function imgUrl(filename, isDefault, assetFolder, campaignId) {
  if (!filename) return null;
  if (typeof filename === 'object') {
    return resolveCustomAssetUrl({
      assetData: filename,
      assetType: 'image',
      campaignId,
      defaultAssetFolder: assetFolder,
    });
  }
  const base = isDefault
    ? getFeatureAssetBaseUrl(true) + (assetFolder || 'wave')
    : getFeatureAssetBaseUrl(false) + 'campaigns/' + campaignId;
  return base + '/image/' + filename;
}

export function audioUrl(filename, isDefault, assetFolder, campaignId) {
  if (!filename) return null;
  if (typeof filename === 'object') {
    return resolveCustomAssetUrl({
      assetData: filename,
      assetType: 'audio',
      campaignId,
      defaultAssetFolder: assetFolder,
    });
  }
  const base = isDefault
    ? getFeatureAssetBaseUrl(true) + (assetFolder || 'wave')
    : getFeatureAssetBaseUrl(false) + 'campaigns/' + campaignId;
  return base + '/audio/' + filename;
}

export function videoUrl(filename, isDefault, assetFolder, campaignId, assetType = 'video') {
  if (!filename) return null;
  if (typeof filename === 'object') {
    return resolveCustomAssetUrl({
      assetData: filename,
      assetType,
      campaignId,
      defaultAssetFolder: assetFolder,
    });
  }
  const base = isDefault
    ? getFeatureAssetBaseUrl(true) + (assetFolder || 'wave')
    : getFeatureAssetBaseUrl(false) + 'campaigns/' + campaignId;
  const resolvedAssetDir = !isDefault && assetType === 'videos' ? 'videos' : 'video';
  return base + '/' + resolvedAssetDir + '/' + filename;
}

// Normalise a filename field: may be a plain string (seeder default)
// or an object { filename, isDefault, srcUrl } (after saving via the UI).
export function normalizeImgField(field) {
  if (!field) return { name: null, isDefault: true, srcUrl: null };
  if (typeof field === 'string') return { name: field, isDefault: true, srcUrl: null };
  return { name: field.filename || null, isDefault: field.isDefault !== false, srcUrl: field.srcUrl || null };
}

export function normalizeAudioField(field) {
  if (!field) return { name: null, isDefault: true, srcUrl: null };
  if (typeof field === 'string') return { name: field, isDefault: true, srcUrl: null };
  return { name: field.filename || null, isDefault: field.isDefault !== false, srcUrl: field.srcUrl || null };
}

export function normalizeVideoField(field) {
  if (!field) return { name: null, isDefault: true, srcUrl: null };
  if (typeof field === 'string') return { name: field, isDefault: true, srcUrl: null };
  return {
    name: field.filename || null,
    isDefault: field.isDefault !== false,
    srcUrl: field.srcUrl || null,
    type: field.type || null,
  };
}

export function getPathValue(obj, keys) {
  if (!obj || !keys || keys.length === 0) return obj;
  let cur = obj;
  for (const k of keys) {
    if (cur == null) return null;
    cur = cur[k];
  }
  return cur;
}

// ─── Position helpers ──────────────────────────────────────────────────────────
export function nx(step, rowOverride) {
  const row  = rowOverride ?? step.layout?.row ?? 0;
  const offX = step.layout?.offsetX ?? 0;
  return PAD_X + row * ROW_STEP + offX;
}

export function ny(step, centreY) {
  const col  = step.layout?.column ?? CENTER_COL;
  const offY = step.layout?.offsetY ?? 0;
  return centreY + (col - CENTER_COL) * COL_STEP + offY;
}

export function stepKind(step) {
  if (step.stepType === 'spacer') return 'spacer';
  if (step.stepType === 'node' && step?.nodeConfig?.nodeStyle === 'infoButton')  return 'infoButton';
  if (step.stepType === 'node' && step?.nodeConfig?.nodeStyle === 'addButton')   return 'addButton';
  if (step.stepType === 'node' && step?.nodeConfig?.nodeStyle === 'decision')    return 'decision';
  if (step.stepType === 'node' && step?.nodeConfig?.nodeStyle === 'outcome')     return 'outcome';
  if (step.stepType === 'node') return 'circle';
  if (step.stepType === 'trigger') return 'trigger';
  // Leaderboard-specific nodes: detect by stepId first (most reliable — no meta dependency)
  if (step?.stepId === 'leaderboard_settings_node') return 'leaderboardSettings';
  if (step?.stepId === 'manual_leaderboard_node')   return 'leaderboardData';
  if (
    step?.stepId === 'start_music_node'
    && step.customisationConfig?.tabKey === 'audio'
    && step.customisationConfig?.varKey === 'triggerSFX'
  ) return 'pollAudio';
  if (
    step?.stepId === 'start_sfx_node'
    && step.customisationConfig?.tabKey === 'audio'
    && step.customisationConfig?.varKey === 'triggerSFX'
  ) return 'audioStack';
  if (step.customisationConfig?.meta?.particleTimer)    return 'particleTimer';
  if (step.customisationConfig?.meta?.particleSettings) return 'particleSettings';
  if (step.customisationConfig?.meta?.leaderboardTrigger) return 'leaderboardTrigger';
  if (step.customisationConfig?.meta?.leaderboardStartAudio) return 'leaderboardStartAudio';
  if (step.customisationConfig?.meta?.leaderboardSettings) return 'leaderboardSettings';
  if (step.customisationConfig?.meta?.leaderboardData) return 'leaderboardData';
  if (
    step?.stepId === 'leaderboard_settings_node'
    && step.customisationConfig?.tabKey === 'leaderboard'
    && step.customisationConfig?.varKey === 'settings'
    && step.customisationConfig?.variables?.[0]?.variableName === 'setup'
  ) return 'leaderboardSettings';
  if (
    step?.stepId === 'manual_leaderboard_node'
    && step.customisationConfig?.tabKey === 'leaderboard'
    && step.customisationConfig?.varKey === 'leaderboardData'
    && step.customisationConfig?.variables?.[0]?.variableName === 'entries'
  ) return 'leaderboardData';
  if (step.customisationConfig?.meta?.particleImageStack) return 'particleImageStack';
  if (step.customisationConfig?.meta?.particleColourStack) return 'particleColourStack';
  if (step.customisationConfig?.meta?.teamWinnerFilter !== undefined) return 'waveWinner';
  if (step.customisationConfig?.meta?.disruptorSelectDataLink) return 'disruptorTrigger';
  if (step.customisationConfig?.meta?.imageStack) return 'imageStack';
  if (step.customisationConfig?.meta?.teamFilter !== undefined) return 'waveGraphics';
  if (step.customisationConfig?.meta?.zapperObjects) return 'zapperObjects';
  if (step.customisationConfig?.meta?.spawnerObjects) return 'zapperObjects';  // same rendering
  if (step.customisationConfig?.meta?.audioStack)     return 'audioStack';
  if (step.customisationConfig?.meta?.pollAudio)      return 'pollAudio';
  if (step.customisationConfig?.meta?.triviaCards)    return 'pollCards';
  if (step.customisationConfig?.meta?.pollCards)      return 'pollCards';
  if (step.customisationConfig?.meta?.pollOutcome)    return 'pollOutcome';
  if (step.customisationConfig?.meta?.slotReels)      return 'slotReels';
  if (step.customisationConfig?.meta?.slotResults)    return 'slotResults';
  // Reels-count selector: detect by data shape (works for existing campaigns without explicit meta)
  if (!step.customisationConfig?.meta &&
    step.customisationConfig?.tabKey === 'setup' &&
    step.customisationConfig?.varKey === 'globalSettings' &&
    step.customisationConfig?.variables?.[0]?.variableName === 'slotSettings') return 'slotReelsCount';
  if (step.customisationConfig?.meta?.goalsNode)      return 'goalsNode';
  if (step.customisationConfig?.meta?.puzzleStack)    return 'puzzleStack';
  if (step.customisationConfig?.meta?.presetTextNode)   return 'presetTextNode';
  if (step.customisationConfig?.meta?.subBombDisplaySettings) return 'subBombDisplaySettings';
  if (step.customisationConfig?.meta?.subBombSpeedControl) return 'subBombSpeedControl';
  if (step.customisationConfig?.meta?.infoBoxNode)       return 'infoBoxNode';
  if (step.customisationConfig?.meta?.statusScreenImageNode) return 'statusScreenImageNode';
  if (step.customisationConfig?.meta?.animatedOverlayMainView) return 'animatedOverlayMainView';
  if (step.customisationConfig?.meta?.countdownSettings) return 'countdownSettings';
  if (step.customisationConfig?.meta?.countdownImageStack) return 'countdownImageStack';
  if (step.customisationConfig?.meta?.countdownTextStack)  return 'countdownTextStack';
  if (step.customisationConfig?.meta?.countdownTimer)    return 'countdownTimer';
  if (step.customisationConfig?.meta?.videoSettings) return 'videoSettings';
  if (step.customisationConfig?.meta?.videoStack) return 'videoStack';
  return 'card';
}

export function goalsNodeHalfW(goalCount) {
  const count = Math.max(goalCount ?? 1, 1);
  const totalW = count * (GOAL_CARD_W + GOAL_CARD_GAP) - GOAL_CARD_GAP + GOALS_NODE_PADDING * 2;
  return Math.max(totalW, CARD_W) / 2;
}

export function halfW(step) {
  const k = stepKind(step);
  if (k === 'spacer') return 0;
  if (k === 'countdownSettings') return COUNTDOWN_SETTINGS_W / 2;
  if (k === 'animatedOverlayMainView') return ANIMATED_OVERLAY_MAIN_VIEW_W / 2;
  if (k === 'videoSettings') return VIDEO_SETTINGS_W / 2;
  if (k === 'leaderboardTrigger') return LEADERBOARD_TRIGGER_W / 2;
  if (k === 'leaderboardStartAudio') return LEADERBOARD_START_AUDIO_W / 2;
  if (k === 'leaderboardSettings') return LEADERBOARD_SETTINGS_W / 2;
  if (k === 'leaderboardData') return LEADERBOARD_DATA_W / 2;
  if (k === 'slotReels') return SLOT_REELS_W / 2;
  if (k === 'slotResults') return SLOT_RESULTS_W / 2;
  if (k === 'slotReelsCount') return SLOT_REELS_COUNT_W / 2;
  if (k === 'videoStack') return VIDEO_CARD_W / 2;
  if (k === 'audioStack') return AUDIO_CARD_W / 2;
  if (k === 'circle')   return CIRCLE_R;
  if (k === 'infoButton') return PLUS_R;
  if (k === 'addButton')  return PLUS_R;
  if (k === 'decision')   return DIAMOND_W / 2;
  if (k === 'outcome')    return OUTCOME_W / 2;
  if (k === 'puzzleStack') return CARD_W / 2;
  if (k === 'trigger') return TRIG_W / 2;
  if (k === 'pollCards') return step.customisationConfig?.meta?.triviaCards ? TRIVIA_NODE_W / 2 : CARD_W / 2;
  if (k === 'presetTextNode') return PRESET_TEXT_W / 2;
  if (k === 'goalsNode') {
    const allVals = step.populatedData?.variables?.[0]?.allValues || [];
    const count = Math.max(allVals.length, 1);
    return goalsNodeHalfW(count);
  }
  return CARD_W / 2;
}

export function halfH(step) {
  const k = stepKind(step);
  if (k === 'spacer') return 0;
  if (k === 'circle')    return CIRCLE_R;
  if (k === 'infoButton') return PLUS_R;
  if (k === 'addButton')  return PLUS_R;
  if (k === 'decision')   return DIAMOND_H / 2;
  if (k === 'outcome')    return OUTCOME_H / 2;
  if (k === 'particleTimer')    return PARTICLE_TIMER_H / 2;
  if (k === 'subBombDisplaySettings') return SUB_BOMB_DISPLAY_H / 2;
  if (k === 'subBombSpeedControl') return SUB_BOMB_SPEED_H / 2;
  if (k === 'infoBoxNode') return INFO_BOX_NODE_H / 2;
  if (k === 'statusScreenImageNode') return IMAGE_STACK_CARD_H / 2;
  if (k === 'animatedOverlayMainView') return ANIMATED_OVERLAY_MAIN_VIEW_H / 2;
  if (k === 'countdownSettings') return COUNTDOWN_SETTINGS_H / 2;
  if (k === 'countdownTimer')    return COUNTDOWN_TIMER_H / 2;
  if (k === 'videoSettings') return VIDEO_SETTINGS_H / 2;
  if (k === 'leaderboardTrigger') return LEADERBOARD_TRIGGER_H / 2;
  if (k === 'leaderboardStartAudio') return LEADERBOARD_START_AUDIO_H / 2;
  if (k === 'leaderboardSettings') return LEADERBOARD_SETTINGS_H / 2;
  if (k === 'leaderboardData') {
    const allVals = step.populatedData?.variables?.[0]?.allValues || [];
    const count = Math.max(allVals.length, 1);
    const bodyH = count * (LEADERBOARD_DATA_ROW_H + LEADERBOARD_DATA_ROW_GAP) - LEADERBOARD_DATA_ROW_GAP;
    return (LEADERBOARD_DATA_HEADER_H + bodyH + LEADERBOARD_DATA_FOOTER_H + 24) / 2;
  }
  if (k === 'slotReels') return SLOT_REELS_NODE_H / 2;
  if (k === 'slotResults') return (SLOT_RESULTS_HEADER_H + SLOT_RESULTS_ROW_H + SLOT_RESULTS_ADD_H + 6) / 2;
  if (k === 'slotReelsCount') return SLOT_REELS_COUNT_H / 2;
  if (k === 'videoStack') {
    const allVals = step.populatedData?.variables?.[0]?.allValues || [];
    return (Math.max(allVals.length, 1) * (VIDEO_CARD_H + VIDEO_CARD_GAP) - VIDEO_CARD_GAP) / 2;
  }
  if (k === 'countdownImageStack') {
    const allVals = step.populatedData?.variables?.[0]?.allValues || [];
    return (Math.max(allVals.length, 1) * (COUNTDOWN_CARD_H + COUNTDOWN_CARD_GAP) - COUNTDOWN_CARD_GAP) / 2;
  }
  if (k === 'countdownTextStack') {
    const allVals = step.populatedData?.variables?.[0]?.allValues || [];
    return (Math.max(allVals.length, 1) * (COUNTDOWN_CARD_H + COUNTDOWN_CARD_GAP) - COUNTDOWN_CARD_GAP) / 2;
  }
  if (k === 'particleSettings') return PARTICLE_SETTINGS_H / 2;
  if (k === 'puzzleStack') {
    const allVals = step.populatedData?.variables?.[0]?.allValues || [];
    return (Math.max(allVals.length, 1) * (PUZZLE_CARD_H + PUZZLE_CARD_GAP) - PUZZLE_CARD_GAP) / 2;
  }
  if (k === 'trigger') return TRIG_H / 2;
  if (k === 'disruptorTrigger') {
    const allVals = step.populatedData?.variables?.[0]?.allValues || [];
    const count = Math.max(allVals.length, 1);
    const cardsH = count * (DISRUPTOR_CARD_H + DISRUPTOR_CARD_GAP) - DISRUPTOR_CARD_GAP;
    return (cardsH + DISRUPTOR_HEADER_H + DISRUPTOR_FOOTER_H) / 2;
  }
  if (k === 'waveWinner') return WINNER_NODE_H / 2;
  if (k === 'waveGraphics') {
    const teamFilter = step.customisationConfig?.meta?.teamFilter;
    const teamAssign = step.customisationConfig?.meta?.teamAssign ?? teamFilter;
    const handFilter = step.customisationConfig?.meta?.handFilter;
    const allVals    = step.populatedData?.variables?.[0]?.allValues || [];
    const items      = teamFilter !== undefined
      ? allVals.filter(v => (v.team === teamAssign || v.team === 2) && (handFilter == null || v.hand === handFilter))
      : allVals;
    return (Math.max(items.length, 1) * (VOTE_CARD_H + VOTE_CARD_GAP) - VOTE_CARD_GAP) / 2;
  }
  if (k === 'zapperObjects') {
    const allVals = step.populatedData?.variables?.[0]?.allValues || [];
    return (Math.max(allVals.length, 1) * (VOTE_CARD_H + VOTE_CARD_GAP) - VOTE_CARD_GAP) / 2;
  }
  if (k === 'imageStack') {
    const allVals = step.populatedData?.variables?.[0]?.allValues || [];
    return (Math.max(allVals.length, 1) * (IMAGE_STACK_CARD_H + IMAGE_STACK_CARD_GAP) - IMAGE_STACK_CARD_GAP) / 2;
  }
  if (k === 'particleImageStack' || k === 'particleColourStack') {
    const allVals = step.populatedData?.variables?.[0]?.allValues || [];
    return (Math.max(allVals.length, 1) * (IMAGE_STACK_CARD_H + IMAGE_STACK_CARD_GAP) - IMAGE_STACK_CARD_GAP) / 2;
  }
  if (k === 'audioStack') {
    const allVals = step.populatedData?.variables?.[0]?.allValues || [];
    return (Math.max(allVals.length, 1) * (AUDIO_CARD_H + AUDIO_CARD_GAP) - AUDIO_CARD_GAP) / 2;
  }
  if (k === 'pollAudio') {
    const slots = step.customisationConfig?.variables || [];
    // Try to approximate actual rendered height using populatedData when available.
    let h = POLL_AUDIO_HEADER_H;
    const populatedVars = step.populatedData?.variables || [];
    for (let i = 0; i < Math.max(slots.length, 1); i++) {
      const slot = slots[i] || {};
      h += POLL_AUDIO_SLOT_LBL_H;
      // Find corresponding populated var by variableName, else fallback to same-index variable
      const varName = slot.variableName;
      const pvar = populatedVars.find(v => v.varName === varName) || populatedVars[i] || {};
      const files = Array.isArray(pvar.allValues) ? pvar.allValues.filter(v => v != null) : [];
      if (files.length === 0) {
        h += POLL_AUDIO_EMPTY_H;
      } else {
        h += files.length * POLL_AUDIO_FILE_H + (files.length - 1) * POLL_AUDIO_FILE_GAP;
      }
      if (slot.allowMultiple) h += POLL_AUDIO_FILE_GAP + POLL_AUDIO_ADD_BTN_H;
      if (i < Math.max(slots.length, 1) - 1) h += POLL_AUDIO_SLOT_GAP;
    }
    // match PollAudioNode TOP_PAD + BOTTOM_PAD
    h += 20 + 52;
    return h / 2;
  }
  if (k === 'pollCards') {
    // Cards are now individually collapsible. Use collapsed height (58px) for layout.
    const COLLAPSED_H = 58;
    const allVals = step.populatedData?.variables?.[0]?.allValues || [];
    const count = Math.max(allVals.length, 1);
    return (count * (COLLAPSED_H + POLL_CARD_GAP) - POLL_CARD_GAP) / 2;
  }
  if (k === 'pollOutcome') return POLL_OUTCOME_H / 2;
  if (k === 'goalsNode') return GOALS_NODE_H / 2;
  if (k === 'presetTextNode') {
    const allVals = step.populatedData?.variables?.[0]?.allValues || [];
    const count = Math.max(allVals.length, 1);
    return (count * (PRESET_TEXT_CARD_H + PRESET_TEXT_CARD_GAP) - PRESET_TEXT_CARD_GAP) / 2;
  }
  return CARD_H / 2;
}
